import { useState } from "react";

import { useTranslation } from "react-i18next";

import { PASSWORD_ERRORS, PasswordErrorValues } from "../../types";

export const usePasswordValidation = () => {
    const { t } = useTranslation();

    const [passwordErrorKey, setPasswordErrorKey] =
        useState<PasswordErrorValues>({
            [PASSWORD_ERRORS.Password1]: null,
            [PASSWORD_ERRORS.Password2]: null
        });

    const clearPasswordError = (passwordName: PASSWORD_ERRORS) => {
        setPasswordErrorKey(prev => ({
            ...prev,
            [passwordName]: null
        }));
    };

    return {
        passwordError: {
            [PASSWORD_ERRORS.Password1]: passwordErrorKey.password1
                ? t(passwordErrorKey.password1)
                : null,
            [PASSWORD_ERRORS.Password2]: passwordErrorKey.password2
                ? t(passwordErrorKey.password2)
                : null
        },
        setPasswordError: setPasswordErrorKey,
        clearPasswordError
    };
};
